<template>
  <div v-if="calldata[0]">
    <vs-breadcrumb>
      <li>
        <a
          aria-current="page"
          style="color: rgba(0, 0, 0, 0.4)"
          title="Device Management"
          >Device Management</a
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li>
        <router-link :to="'sensordashboard'" title="Sensor">Device</router-link
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">History Log</li>
    </vs-breadcrumb>

    <vs-card style="border-radius: 20px">
      <!-- <vs-row class="mt-2 mb-4" id="center">
          <vs-button color="success" to="/sensordashboard" type="flat" ><vs-icon  icon="keyboard_backspace"  size="18px" color="success"></vs-icon></vs-button>
        <h3 class="ml-1" style="color: #111111">
           History Log
        </h3>
        <vs-spacer />
           <btnPrint :dataList="calldata" :headerName="'History Log'" :header="List" />
           <btnPDF :dataList="sensorlist" :headerName="'Sensor'" :header="header" />
           <btnExportXLSX :dataList="sensorlist" :headerName="'Sensor'" :header="header" />
         
        </vs-row>  -->
      <vs-row class="mt-4 mb-3">
        <vs-col
          style="padding-left: unset"
          vs-type="flex"
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <h6>Filters :</h6>
          <v-select
            style="min-width: 300px"
            class="ml-1"
            multiple
            v-model="selectFilter"
            :options="header"
          />
          <vs-button
            color="success"
            class="ml-1"
            @click="inputFilter()"
            style="border-radius: 10rem; padding: 5px 15px"
            type="filled"
            >Search</vs-button
          >
        </vs-col>
      </vs-row>
      <vs-row
        id="center"
        class="mb-2"
        style="display: flex; align-items: center"
        :key="index"
        v-for="(item, index) in selectFilter"
      >
        <vs-icon
          icon="delete"
          id="btns"
          @click="removeItem(item, index, filtervalue)"
          size="18px"
          color="danger"
        ></vs-icon>
        <span class="mr-2 ml-1">{{ item }} :</span>
        <input
          class="inputx w3-input"
          style="width: 260px"
          @keydown.enter="inputFilter()"
          v-model="filtervalue[index]"
        />
      </vs-row>
      <div class="table-responsive">
        <vs-table
          :data="calldata"
          :max-items="descriptionItems[0]"
          pagination
          description
          search
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
          style="background-color: #f2f3f4; border-radius: 20px"
        >
          <template slot="header">
            <h5 class="ml-3">History Log</h5>
          </template>
          <template slot="thead">
            <vs-th
              id="noWrap"
              v-for="(head, indexh) in list"
              :key="indexh"
              sort-key="sensorid"
            >
              {{ head }}<span><vs-icon icon="unfold_more" size="13px"></vs-icon></span>
            </vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :key="indextd" v-for="(td, indextd) in tr">
                <div
                  v-if="
                    indextd == 'time' ||
                    indextd == 'timestamp' ||
                    indextd == 'Timestamp' ||
                    indextd == 'date' ||
                    indextd == 't'
                  "
                >
                  {{ $moment(tr[indextd]).format("YYYY-MM-DD HH:mm:ss") }}
                </div>
                <div :data="data[indextr].sensorid" v-else>
                  {{ tr[indextd] }}
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-card>
  </div>
</template>
<script>
import btnPrint from "../Button/btnPrint.vue";
export default {
  name: "sensorpage",
  components: { btnPrint },
  props: ["data", "sensorid", "gatewayid", "nwid", "nwname", "type", "list"],
  data: () => ({
    list: [],
    calldata: [],
    descriptionItems: [15, 30, 40],
  }),
  methods: {
    back() {
      this.$router.push({
        name: "Sensor",
        params: {
          sensorid: this.sensorid,
          nwid: this.nwid,
          calldata: this.data,
          type: this.type,
          nwname: this.nwname,
        },
      });
    },
  },
    mounted() {
      // console.log(this.sensorid)
      this.admin = this.$session.get("admin")
      if (!!!this.sensorid) {
        this.sensorid = this.$session.get("sensorid")
      }
      else {
        this.$session.set("sensorid", this.sensorid)
      }
      if (!!!this.gatewayid) {
        this.gatewayid = this.$session.get("gatewayid")
      }
      else {
        this.$session.set("gatewayid", this.gatewayid)
      }
      this.$vs.loading()
      this.$API.get('sensor/log/serial-id/'+this.sensorid+'/gateway/'+this.gatewayid).then((result) => {
        console.log('sensor/log/serial-id/'+this.sensorid+'/gateway/'+this.gatewayid)
        this.calldata = result.data
        console.log(this.calldata)
        console.log(this.admin)
        let obj = {...this.calldata[0]}
        if (this.admin == "QCONdemo") {
            delete obj.rssi;
            delete obj.battery;
          }
        this.list = Object.keys(obj)
        this.calldata.forEach(element => {
          delete element.users_id
          // console.log(element.t)
          if (this.admin == "QCONdemo") {
            delete element.rssi;
            delete element.battery;
          }
          if (this.type == "advantech" || this.type == "ssc") {
            if(element.hasOwnProperty('t')) {
              element.Timestamp = this.$moment(element.t).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              delete element.t;
              delete element.q;
              delete element.c;
              delete element.s;
            }else{
              element.timestamp = this.$moment(element.timestamp).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
          }
        });
        switch (this.type) {
          case "control":
            this.list = []
            // eslint-disable-next-line no-console
            // console.log(this.calldata[0])
            this.calldata.forEach((e, i) => {
              delete this.calldata[i].serial_id;
              delete this.calldata[i].id;
              delete this.calldata[i].control;
              delete this.calldata[i].jtimestamp;
            });
            Object.keys(this.calldata[0]).forEach((element) => {
              // eslint-disable-next-line no-console
              // console.log(element)
            });
            Object.keys(this.calldata[0]).forEach((e) => {
              this.list.push(e);
            });
            break;
          // default:
          //   Object.keys(this.calldata[0]).forEach((e) => {
          //     this.list.push(e);
          //   });
          //   break;
        }
        setTimeout(() => {
          console.log(this.calldata)
          this.$vs.loading.close();
        }, 100);
      });
    // eslint-disable-next-line no-console
    // console.log(this.list)
    // console.log(this.calldata)
  },
};
</script>
<style scoped>
#noWrap {
  padding: 0px;
  white-space: nowrap;
  font-size: 0.75rem;
}
#center {
  display: flex;
  align-items: center;
}
</style>